import { __read } from "tslib";
import { useCallback, useEffect, useRef, useState } from 'react';
export function useTooltipState(props) {
    var _a = props.defaultVisible, defaultVisible = _a === void 0 ? false : _a, _b = props.openDelay, openDelay = _b === void 0 ? 0 : _b, _c = props.closeDelay, closeDelay = _c === void 0 ? 0 : _c;
    var _d = __read(useState(defaultVisible), 2), visible = _d[0], setVisible = _d[1];
    var openTimeoutRef = useRef();
    var closeTimeoutRef = useRef();
    var changeVisibility = useCallback(function (value) {
        var resetRef = value ? closeTimeoutRef : openTimeoutRef;
        var timeoutRef = value ? openTimeoutRef : closeTimeoutRef;
        var delay = value ? openDelay : closeDelay;
        if (resetRef.current) {
            clearTimeout(resetRef.current);
            resetRef.current = undefined;
        }
        if (delay > 0) {
            if (!timeoutRef.current) {
                timeoutRef.current = window.setTimeout(function () {
                    timeoutRef.current = undefined;
                    setVisible(value);
                }, delay);
            }
        }
        else {
            setVisible(value);
        }
    }, [openDelay, closeDelay]);
    var showTooltip = useCallback(function () { return changeVisibility(true); }, [changeVisibility]);
    var hideTooltip = useCallback(function () { return changeVisibility(false); }, [changeVisibility]);
    var toggleTooltip = useCallback(function () { return changeVisibility(!visible); }, [visible, changeVisibility]);
    useEffect(function () {
        return function () {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            clearTimeout(openTimeoutRef.current);
            // eslint-disable-next-line react-hooks/exhaustive-deps
            clearTimeout(closeTimeoutRef.current);
        };
    }, []);
    return {
        visible: visible,
        open: showTooltip,
        close: hideTooltip,
        toggle: toggleTooltip,
    };
}
